import FunctionHeader from "presentation/components/Header/FunctionHeader";
import SettingPanel from "presentation/components/Setting/SettingPanel/indext";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";

const SettingPage = ({ children }: { children?: React.ReactNode }) => {
  const { isLoading } = usePermissionCheck({ requiredFunction: "settings" });

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <div>
      <FunctionHeader title="Configurações" />
      <SettingPanel />
    </div>
  );
};

export default SettingPage;
